import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import style from './style.scss';

export const CustomizedSelect = (props) => {
  const [isVisited, setIsVisited] = useState(false);
  const [isRequired, setIsRequired] = useState(false);
  const {
    data,
    value,
    label,
    className,
    labelClassName,
    onChange,
    hasError,
    errorMessage,
    isRequired: isRequiredProps,
    isBadgeVisible,
    placeHolder,
    isDisabled,
    hasDefault,
    isErrorVisible,
    ...restProps
  } = props;

  const handleBlur = (e) => {
    const { value: targetValue } = e.target;
    setIsVisited(true);
    if (targetValue) {
      setIsRequired(false);
    } else {
      setIsRequired(isRequiredProps);
    }
  };

  return (
    <label className={cn({ selectLabel: true, 'has-value': true, required: (isVisited && isRequired) || hasError }, style.label, labelClassName)}>
      {
        label &&
        <span style={{ zIndex: 1 }}>{label} {
          isBadgeVisible && ((isVisited && isRequiredProps) || hasError) && <em>Required</em>
          }
          {
            isBadgeVisible && isVisited && !isRequiredProps && <em>Optional</em>
          }
        </span>
      }
      <select
        onChange={onChange}
        onBlur={handleBlur}
        className={cn(style.select, className)}
        disabled={isDisabled}
        {...restProps}
        value={value}
      >
        { hasDefault && <option value="">Select ...</option> }
        {
          data && data.map((item, key) => (<option key={key} value={item.value}>{item.title}</option>))
        }
      </select>
      {
        isErrorVisible &&
        <div className={style.error}>{errorMessage !== 'The input field is required' && errorMessage}</div>
      }
    </label>
  );
};

CustomizedSelect.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  data: PropTypes.array,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  placeHolder: PropTypes.string,
  isBadgeVisible: PropTypes.bool,
  isDisabled: PropTypes.bool,
  hasDefault: PropTypes.bool,
  isErrorVisible: PropTypes.bool,
};

CustomizedSelect.defaultProps = {
  className: '',
  labelClassName: '',
  hasError: false,
  errorMessage: '',
  label: null,
  name: '',
  value: '',
  isRequired: false,
  placeHolder: 'Select ...',
  data: null,
  isBadgeVisible: true,
  isDisabled: false,
  hasDefault: true,
  isErrorVisible: true,
};

export default CustomizedSelect;



// WEBPACK FOOTER //
// ./src/components/Form/Select/index.js